import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useTabPanel } from '../hooks';

// Note this is not being memoized as children is an unstable reference

/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */
const TabPanel = ({
  children,
  testId
}) => {
  const tabPanelAttributes = useTabPanel();
  return jsx("div", _extends({
    "data-testid": testId
  }, tabPanelAttributes), children);
};

export default TabPanel;